import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { forkJoin, Subject } from "rxjs";
import { Agent, AgentClient, AgentService, AgentServicesClient, DeliverService, DeliverServicesClient, DocumentClient, Documents, DocumentServices, DocumentTypeClient, DocumentTypes, NServices, ServiceClient } from "src/app/web-api-client";
import { DocumentTypeLink } from "../../../../models/documentTypeLink.enum";
import { SigningType } from "../../../../models/signing-Type.enum";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-documents-edit',
  templateUrl: './documents-edit.component.html',
  styleUrls: ['./documents-edit.component.scss']
})
export class DocumentEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: Documents;
  public editServiceObject: DocumentServices;
  public services: NServices[];
  public documentTypes: DocumentTypes[] = [];
  public SigningType = SigningType;
  public signingTypes = Object.keys(SigningType).filter(
    key => !isNaN(Number(SigningType[key]))
  );

  public onClose = new Subject<boolean>();

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: DocumentClient, public docTypeClient: DocumentTypeClient, public serviceClient:ServiceClient) { }

  ngOnInit(): void {

    forkJoin([this.serviceClient.getList(), this.docTypeClient.getList()])
      .subscribe(([services, docTypes]) => {

        this.services = services;
        this.documentTypes = docTypes;
        this.initializeForm();
        this.isLoaded = true;

      })

  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      description: [this.editObject.description, Validators.required],
      documentTypes: [this.editObject.idDocumentType, Validators.required],
      documentLinkType: [this.editObject.documentTypeLink, Validators.required],
      isGlobal: [this.editObject.isGlobal, Validators.required],
      signedType: [+this.editObject.signedType, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {

      this.editObject.title = this.Form.value.title;
      this.editObject.description = this.Form.value.description;
      this.editObject.idDocumentType = this.Form.value.documentTypes;
      this.editObject.documentTypeLink = this.Form.value.documentLinkType;
      this.editObject.isGlobal = this.Form.value.isGlobal;
      this.editObject.signedType = this.Form.value.signedType;
      this.editObject.isActive = this.Form.value.isActive;



      this.client.update(this.editObject).subscribe((user) => {

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public isSelected(service:Documents) {
    let result = this.editObject.idDocument == service.idDocument;
    return result;
  }

  public getSigningType(linkType: number) {
    switch (linkType) {
      case SigningType.NoSigning:
        return "Без Подпис";
      case SigningType.SignRequired:
        return "Изисква Подпис";
    }

    return "";
  }

  public getDocTypeLink(linkType: number) {
    switch (linkType) {
      case DocumentTypeLink.Service:
        return "Услуга";
      case DocumentTypeLink.Agent:
        return "Доставчик";
      case DocumentTypeLink.ServiceProvider:
        return "Доставчик на услуги";
    }

    return "";
  }

}
